import { render, staticRenderFns } from "./UserAcknowledge.vue?vue&type=template&id=c8dbf83e&scoped=true&"
import script from "./UserAcknowledge.vue?vue&type=script&lang=js&"
export * from "./UserAcknowledge.vue?vue&type=script&lang=js&"
import style0 from "./UserAcknowledge.vue?vue&type=style&index=0&id=c8dbf83e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dbf83e",
  null
  
)

export default component.exports